import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'assessment-row',
  template: `
  <div class="container" [ngClass]="{ 'history-mode': historyMode() }">
    <div class="header">
      <h3 class="title">{{ title() }}</h3>
      @if (subtitle()) {
        <i class="subtitle">{{ subtitle() }}</i>
      }
      @if (description()) {
        <p class="description">{{ description() }}</p>
      }
    </div>
    <div class="content-container">
      <ng-content class="content"></ng-content>
    </div>
  </div>`,
  styles: `
  /* BASE STYLES */
  .container {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }
  .header {
    flex: 1;
  }
  .header .title {
    margin-bottom: 0;
    font-weight: bold;
  }
  .content-container {
    flex: 2;
    align-items: center;
  }

  /* HISTORY MODE */
  .container.history-mode {
    background: var(--emr-history-bg, #f7f8fa);
    border-left: 4px solid var(--emr-history-border, #1976d2);
    border-radius: 4px;
    margin-bottom: 0.5rem;
    box-shadow: 0 1px 2px rgba(0,0,0,0.03);
    padding: 0.5rem 1rem;
  }

  .container.history-mode .title {
    color: var(--emr-label-muted, #888);
    font-weight: 500;
    opacity: 0.8;
  }

  .container.history-mode .content-container {
    color: var(--emr-value-strong, #111);
    font-weight: 700;
    letter-spacing: 0.01em;
  }
  `,
  standalone: true,
  imports: [CommonModule],
})
export class AssessmentRowComponent {
  title = input('');
  subtitle = input('');
  description = input('');

  /**
   * If true, applies history-mode styling.
   * Defaults to false, so the Input Page remains untouched.
   */
  historyMode = input(false);
}